import { render, staticRenderFns } from "./addFbpBand.vue?vue&type=template&id=e58000ac&scoped=true"
import script from "./addFbpBand.vue?vue&type=script&lang=js"
export * from "./addFbpBand.vue?vue&type=script&lang=js"
import style0 from "./addFbpBand.vue?vue&type=style&index=0&id=e58000ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e58000ac",
  null
  
)

export default component.exports